<template>
    <div v-if="config.modules.vouchers && loaded && cart.products.length && available_vouchers.length">
        <h4>{{ t.vouchers.available_vouchers}}</h4>
        <div class="row">
            <div class="col-12 col-md-3 mb-3" v-for="voucher in available_vouchers" :key="voucher.id">
                <div class="border border-dashed border-2px p-3 h-100">
                    <div class="lead">{{ t.vouchers.code}}: <span class="fw-bold">{{ voucher.code }}</span></div>
                    <div class="lead mb-1">{{ voucher.label }}</div>
                    <div class="small text-muted">
                        <div v-if="voucher.date_start">{{ t.vouchers.date_start}}: <b>{{ voucher.formattedDateStart }}</b></div>
                        <div v-if="voucher.date_end">{{ t.vouchers.date_end}}: <b>{{ voucher.formattedDateEnd }}</b></div>
                        <div v-if="voucher.products.length" class="mt-2">
                            <b>{{ t.vouchers.available_for_product}}:</b> <div class="ms-2" v-for="product in voucher.products" :key="product.id">{{product.name}}</div>
                        </div>
                    </div>
                    <button class="btn btn-secondary btn-sm mt-2" @click="applyVoucher(voucher.code)">{{ t.vouchers.apply_voucher }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                config: window.config,
                t: window.t,
            }
        },
        mounted() {
            this.$store.dispatch('getCart')
            this.$store.dispatch('getAvailableVouchers')
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'cart', 'available_vouchers']),
        },
        methods: {
            ...Vuex.mapActions(['applyVoucher']),
        }
    }
</script>
